import { createContext, useContext } from "react";

/**
 * RoninPreviewContext — published by RoninPreviewAdmin so the runner can opt-in to
 * "report what cue is firing right now" behavior. Mounted in user-facing Ronin Box
 * the context is null → runner reports nothing → zero overhead.
 *
 * Shape: { onCueFired: (cue) => void } | null
 */
const RoninPreviewContext = createContext(null);

export function RoninPreviewProvider({ value, children }) {
  return (
    <RoninPreviewContext.Provider value={value}>
      {children}
    </RoninPreviewContext.Provider>
  );
}

export function useRoninPreview() {
  return useContext(RoninPreviewContext);
}
